import { error } from '@react/react-spectrum/Toast';
import { useContext, useEffect, useMemo, useState } from 'react';

import { featuredApi, handleApiCall } from '@exchange-frontends/api';

import { ContainerContext } from '../../../utils';

/**
 * Custom hook that's fetching featured apps for the specified cloud
 * @param {('CC'|'EC'|'DC')} [cloud='EC'] - the cloud you want the featured apps for
 */
export const useFeaturedApps = (cloud = 'EC') => {
  const { ims } = useContext(ContainerContext);
  const accessToken = useMemo(() => ims?.getAccessToken()?.token, [ims]);
  const [loading, setLoading] = useState(true);
  const [encounteredError, setEncounteredError] = useState(false);
  const [apps, setApps] = useState(null);

  useEffect(() => {
    let mounted = true;
    const handler = handleApiCall(featuredApi.featuredApps, { cloud, authToken: accessToken });
    (async () => {
      try {
        setLoading(true);
        setEncounteredError(false);
        const response = await handler.run();
        if (mounted) {
          setApps(response);
        }
      } catch (err) {
        if (err.code !== 20) {
          error(err.userMessage, { timeout: 0 });
          console.error(err);
          if (mounted) {
            setEncounteredError(true);
          }
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    })();
    return () => {
      mounted = false;
      handler.controller.abort();
    };
  }, [accessToken, cloud]);

  return {
    loading,
    encounteredError,
    apps,
  };
};
